import { Box, Button } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const GoldReview = ({ data, noEdit, defaults }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <div>
      {" "}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { md: "90%", xs: "90%" },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
          overflow: "auto",
          maxHeight: "95%",
          maxWidth: "400px",
        }}
      >
        <div className="flex flex-col gap-4">
          <div className="border-b border-solid border-[#bbcfec] pb-4">
            <h2 className="text-sm font-bold">{data?.chTitle}</h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">عنوان ارسالی : </span>
            <h2 className="text-sm font-bold">{data?.chSellerStuffSendName}</h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">تعداد : </span>
            <h2 className="text-sm font-bold">
              {data?.flAmount} {data?.chMeasurementUnitName}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm "> مبلغ واحد : </span>
            <h2 className="text-sm font-bold">
              {data?.moUnitPrice?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm "> اجرت ساخت : </span>
            <h2 className="text-sm font-bold">
              {data?.moConstructionPrice?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm "> سود فروشنده : </span>
            <h2 className="text-sm font-bold">
              {data?.moProfitPrice?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
          {data?.moWorkPrice ? (
            <div className="flex items-center gap-2">
              <span className="text-sm "> حق العمل : </span>
              <h2 className="text-sm font-bold">
                {data?.moWorkPrice?.toLocaleString("en-US")} ریال{" "}
              </h2>
            </div>
          ) : (
            <></>
          )}

          <div className="flex items-center gap-2">
            <span className="text-sm ">مبلغ تخفیف : </span>
            <h2 className="text-sm font-bold">
              {data?.moDiscount?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm ">مبلغ ارزش افزوده :</span>
            <h2 className="text-sm font-bold">
              {data?.moValueAddedPrice?.toLocaleString("en-US")} ریال{" "}
            </h2>
          </div>
        </div>
        <div className="flex col-span-2 justify-center items-center mt-5">
          <Button
            onClick={() => {
              if (id) {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/${id}`);
              } else {
                navigate(`/sell/${noEdit ? "preview" : "invoice"}/create`);
              }
            }}
            sx={{ width: "8rem", background: "#ccc" }}
            variant="contained"
            color="inherit"
          >
            بازگشت
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default GoldReview;
